export default __webpack_public_path__ + "static/media/portfolio-119.81f91e48.jpg";